var map = {
	"./0_stat.png": 3857,
	"./1_stat.png": 8445,
	"./2_stat.png": 858,
	"./3_stat.png": 6626,
	"./4_stat.png": 2942,
	"./5_stat.png": 3471,
	"./6_stat.png": 3708,
	"./7_stat.png": 1594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 861;